import React from 'react';
import { Box } from '@mui/material';

export const STAGING_BANNER_HEIGHT = 32;
export const isStagingEnv = typeof window !== 'undefined' && window.location.hostname.startsWith('staging');

const StagingBanner: React.FC = () => {
  if (!isStagingEnv) return null;

  const repeated = Array(20).fill('AMBIENTE DI STAGING').join('   •   ');

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: `${STAGING_BANNER_HEIGHT}px`,
        backgroundColor: '#d32f2f',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        fontWeight: 700,
        fontSize: '13px',
        letterSpacing: '1px',
        zIndex: (theme) => theme.zIndex.drawer + 10,
        userSelect: 'none',
      }}
    >
      <Box sx={{ width: '100%', textAlign: 'center' }}>
        {repeated}
      </Box>
    </Box>
  );
};

export default StagingBanner;